(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("timepicker", [], factory);
	else if(typeof exports === 'object')
		exports["timepicker"] = factory();
	else
		root["timepicker"] = factory();
})(this, function() {
return 